import { useState } from 'react'
import { usePwaInstall } from './usePwaInstall'
import { IosInstallHelp } from './IosInstallHelp'

/**
 * Bouton « Installer l'app » inline. `variant` adapte le style au contexte :
 * 'menu' (entrée de menu mobile) ou 'card' (page Capitaine). Rien à afficher
 * si déjà installée, ou ni installable ni iOS.
 */
export function InstallAppButton({
  variant = 'menu',
  onDone,
}: {
  variant?: 'menu' | 'card'
  onDone?: () => void
}) {
  const { canInstall, isStandalone, isIosSafari, promptInstall } = usePwaInstall()
  const [showIosHelp, setShowIosHelp] = useState(false)

  if (isStandalone || (!canInstall && !isIosSafari)) return null

  const handle = async () => {
    if (canInstall) {
      await promptInstall()
      onDone?.()
    } else {
      // iOS : la fiche d'instructions est un overlay porté par ce composant.
      // Ne PAS appeler onDone (ex. closeMenu) ici : cela démonterait le sous-arbre
      // du menu — et donc la modale — avant qu'elle ne soit peinte. La fiche est
      // plein écran, refermer le menu en dessous n'apporte rien.
      setShowIosHelp(true)
    }
  }

  const className =
    variant === 'menu'
      ? 'px-3 py-2.5 rounded-md text-base text-left text-sand-200 hover:bg-ocean-700/40 transition-colors'
      : 'inline-flex items-center gap-2 rounded-md bg-ocean-700 px-4 py-2 text-sm text-sand-100 border border-sand-500/30 hover:bg-ocean-500 transition-colors'

  return (
    <>
      <button type="button" onClick={handle} className={className}>
        Installer l'app
      </button>
      {showIosHelp && <IosInstallHelp onClose={() => setShowIosHelp(false)} />}
    </>
  )
}
